import PropTypes from 'prop-types';
import React, { useCallback } from 'react';

import { cls } from '@mssgme/helpers';

import styles from './ScrollableBox.scss';

// TODO: remove
export const ScrollableBox = ({ nopadding, noHeader, onBottomScroll, ...rest }) => {
    const handleScroll = useCallback(({ target }) => {
        if (onBottomScroll && target.scrollHeight - target.scrollTop < target.clientHeight + 1) {
            onBottomScroll();
        }
    }, [onBottomScroll]);

    return (
        <div
            onScroll={handleScroll}
            {...cls([styles.root, nopadding && styles.noPadding, noHeader && styles.noHeader], rest)}
        />
    );
};

ScrollableBox.propTypes = {
    className: PropTypes.string,
    nopadding: PropTypes.bool,
    noHeader: PropTypes.bool,
    onBottomScroll: PropTypes.func,
};
